import moment from "moment";
import LogMessageCellRenderer from "../../PPTPromosGrid/cell-renderers/LogMessageCellRenderer";

export const defaultColumnDef = {
  resizable: true,
  wrapText: true,
  autoHeight: true,
  width: 80,
  sortable: true,
  filter: false,
  suppressHeaderMenuButton: true,
};

export const columnDefs = [
  {
    colId: "occurredAt",
    field: "occurredAt",
    headerName: "Date & Time",
    width: 200,
    sortable: true,
    valueFormatter: ({ value }) =>
      value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "",
  },
  {
    colId: "actorDisplayName",
    field: "actorDisplayName",
    headerName: "User",
    width: 150,
    sortable: true,
  },
  {
    colId: "description",
    field: "description",
    headerName: "Log",
    flex: 1,
    wrapText: true,
    // autoHeight: true, // Not supported with server-side row model
    sortable: true,
    cellRenderer: LogMessageCellRenderer,
  },
];
